import jsonToFormData from "json-form-data"

const abortErrors = ['AbortError', 'NetworkError', 'TypeError', 'aborting previous request']

export const NETWORK_ERROR_MESSAGE = "Connexion impossible, vérifiez votre connexion internet et réessayez."

/**
 * Requête qui n'a pas abouti (réseau coupé, réponse non JSON, requête annulée).
 * `message` reste un texte : les écrans l'affichent tel quel, et un objet Error rendu
 * par React fait planter toute la page.
 */
const requestFailed = (error) => {
    console.error("Error fetching data:", error);
    if (abortErrors.includes(error)) {
        console.log('Fetch aborted');
    } else {
        // Handle other errors
        console.error('Fetch error:', error);
    }
    return {error: true, network: true, message: NETWORK_ERROR_MESSAGE, cause: error};
}

class ApiService {
    controller = undefined;
    constructor() {}

    async get(url, data = {}, allowAbort = true) {
        const headers = {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
        let requestOptions = {
            method: "GET"
        }
        if (allowAbort) {
            this.controller?.abort("aborting previous request");
            this.controller = new AbortController();
            requestOptions = {
                headers,
                signal: this.controller.signal,
                ...requestOptions
            }
        } else {
            requestOptions = {
                headers,
                ...requestOptions
            }
        }

        return fetch(url + '?' + new URLSearchParams(data),
            requestOptions
        ).then((response) =>
            response.json()
        ).then( (json) => {
            console.log("result", json);
            this.controller = undefined;
            return json
        }).catch(requestFailed)
    }

    async post(url, data = null, allowAbort = true) {
        const headers = {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
        let requestOptions = {
            method: "POST",
            body: JSON.stringify(data)
        }
        
        if (allowAbort) {
            this.controller?.abort("aborting previous request");
            this.controller = new AbortController();
            requestOptions = {
                headers,
                signal: this.controller.signal,
                ...requestOptions
            }
        } else {
            requestOptions = {
                headers,
                ...requestOptions
            }
        }

        return fetch(url, 
            requestOptions
        ).then((response) =>
            response.json()
        ).then( (json) => {
            console.log("result", json);
            this.controller = undefined;
            return json;
        }).catch(requestFailed)
    }

    async postFormData(url, data = {}, allowAbort = true) {
        const headers = {
            'Accept': 'application/json',
            // 'Content-Type': 'multipart/form-data'
        }
        let formData = jsonToFormData(data)

        let requestOptions = {
            method: "POST",
            body: formData
        }
        
        if (allowAbort) {
            this.controller?.abort("aborting previous request");
            this.controller = new AbortController();
            requestOptions = {
                headers,
                signal: this.controller.signal,
                ...requestOptions
            }
        } else {
            requestOptions = {
                headers,
                ...requestOptions
            }
        }

        return fetch(url, 
            requestOptions
        ).then((response) =>
            response.json()
        ).then( (json) => {
            console.log("result", json);
            this.controller = undefined;
            return json;
        }).catch(requestFailed)
    }
}
const apiService = new ApiService();
export default apiService;

